import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight } from "lucide-react";

/**
 * First-run checklist card for new sellers. Renders on SellerDashboard when
 * mine.length === 0 (no products yet). Once they publish, the card is hidden.
 */
export default function OnboardingChecklist({ user, hasProducts, payoutsConnected = false }) {
  if (hasProducts && payoutsConnected) return null;
  const steps = [
    { done: true, label: "Create your seller account", href: null },
    { done: payoutsConnected, label: "Connect your bank for direct payouts", href: "/payouts", cta: "Connect" },
    { done: hasProducts, label: "Publish your first product (goes live instantly)", href: "/seller/new", cta: "Publish" },
    { done: false, label: "Share your referral link and earn $25 per signup", href: "/referrals", cta: "Share" },
  ];
  return (
    <div
      data-testid="seller-onboarding"
      className="mt-6 rounded-xl border border-[#007AFF]/40 bg-[#007AFF]/[0.06] p-6"
    >
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-[#007AFF]">Onboarding</div>
          <h2 className="mt-1 font-black text-xl tracking-tight">Get to your first sale in under 3 minutes</h2>
        </div>
        <div className="text-[10px] uppercase tracking-widest text-neutral-500">
          {steps.filter((s) => s.done).length} of {steps.length} done
        </div>
      </div>
      <ul className="mt-5 space-y-3">
        {steps.map((s, i) => (
          <li key={i} className="flex items-center gap-3">
            {s.done ? (
              <CheckCircle2 className="h-5 w-5 text-[#34C759]" />
            ) : (
              <Circle className="h-5 w-5 text-neutral-500" />
            )}
            <span className={`text-sm flex-1 ${s.done ? "line-through text-neutral-500" : "text-white"}`}>
              {s.label}
            </span>
            {!s.done && s.href && (
              <Link
                to={s.href}
                data-testid={`onboarding-cta-${i}`}
                className="text-xs font-semibold text-[#007AFF] hover:text-white inline-flex items-center gap-1"
              >
                {s.cta} <ArrowRight className="h-3 w-3" />
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
